/**
 * Single source of truth for OKD cluster console URLs. Previously hardcoded
 * twice (constants/portalPages.ts and components/SectionMenu.tsx), with no
 * guarantee the two lists stayed in sync when a cluster was added/changed.
 */
export interface OkdCluster {
  id: string;
  consoleUrl: string;
}

export const OKD_CLUSTERS: OkdCluster[] = [
  { id: 'us-east-1', consoleUrl: 'https://console-openshift-console.apps.okd-1.us-east-1.wrk-1.aws.hydra.verint.com' },
  { id: 'eu-central-1', consoleUrl: 'https://console-openshift-console.apps.okd-1.eu-central-1.wrk-1.aws.hydra.verint.com' },
  { id: 'us-east-2', consoleUrl: 'https://console-openshift-console.apps.okd-1.us-east-2.wrk-1.aws.hydra.verint.com' },
  { id: 'us-west-2', consoleUrl: 'https://console-openshift-console.apps.okd-1.us-west-2.wrk-1.aws.hydra.verint.com' },
  { id: 'ca-central-1', consoleUrl: 'https://console-openshift-console.apps.okd-1.ca-central-1.wrk-1.aws.hydra.verint.com' },
  { id: 'eu-west-2', consoleUrl: 'https://console-openshift-console.apps.okd-1.eu-west-2.wrk-1.aws.hydra.verint.com' },
  { id: 'ap-southeast-1', consoleUrl: 'https://console-openshift-console.apps.okd-1.ap-southeast-1.wrk-1.aws.hydra.verint.com' },
  { id: 'ap-southeast-2', consoleUrl: 'https://console-openshift-console.apps.okd-1.ap-southeast-2.wrk-1.aws.hydra.verint.com' },
  { id: 'af-south-1', consoleUrl: 'https://console-openshift-console.apps.okd-1.af-south-1.wrk-1.aws.hydra.verint.com' },
  { id: 'eus-azure', consoleUrl: 'https://console-openshift-console.apps.okd-1.eus.wrk-1.azure.hydra.verint.com' },
  { id: 'gwc-azure', consoleUrl: 'https://console-openshift-console.apps.okd-1.gwc.wrk-1.azure.hydra.verint.com' },
  { id: 'beta-us-east-2', consoleUrl: 'https://console-openshift-console.apps.beta.us-east-2.wrk-1.aws.hydra.verint.com' },
  { id: 'mgmt-1', consoleUrl: 'https://console-openshift-console.apps.mgmt-1.hydra.verint.com' },
];

export function okdConsoleUrl(id: string): string {
  const cluster = OKD_CLUSTERS.find(c => c.id === id);
  if (!cluster) throw new Error(`Unknown OKD cluster id: ${id}`);
  return cluster.consoleUrl;
}
